import script from "./PutIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./PutIn.vue?vue&type=script&setup=true&lang=ts"

import "./PutIn.vue?vue&type=style&index=0&id=6303c067&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6303c067"]])

export default __exports__